import React from "react";
import { useState, useContext, useEffect } from "react";
import Item from "./Item";
import API from "../../api/client";
import * as ENDPOINTS from "../../api/endpoints";
import { LoaderContext } from "../utils/Contexts";
import { useDispatch, useSelector } from "react-redux";
import { cartFetch } from "../../features/cartSlice";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

function Favouriteitems(props) {
  const { t } = useTranslation();
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const { isLoader, setLoader } = useContext(LoaderContext);
  const dispatch = useDispatch();
  const cartData = useSelector((state) => state.cart.cartData);
  const cartItems = useSelector((state) => state.cart.cartItems);
  const [existingItemsInCart, setExistingItemsInCart] = useState([]);
  // Function to check if a product is a favorite
  const isFavorite = (productId) => {
    return props.favouriteItems.some((fav) => {
      if (fav?.favorite && fav.favorite.length > 0) {
        return fav.favorite[0].cusId == props.cusId &&
          fav.favorite[0].productId == productId
          ? true
          : false;
      } else if (
        fav.productId &&
        productId &&
        fav.productId._id === productId
      ) {
        return true;
      }

      return false;
    });
  };
  useEffect(() => {
    if (cartItems.length > 0) {
      let existingItems = [];
      cartItems.forEach((element) => {
        existingItems[element.product_id] = element.qty;
      });
      setExistingItemsInCart(existingItems);
    }
  }, []);
  useEffect(() => {
    setTimeout(() => {
      dispatch(cartFetch());
      setLoader(false);
    }, 1500);
  }, [dispatch, cartItems]);
  const addToFavorite = async (event, item) => {
    //console.log("item", item);
    setLoader(true);

    try {
      let response;
      let message;
      let itemId = item._id;
      if (item?.product?._id) {
        itemId = item.product._id;
      }
      // Check if the product is already a favorite
      if (item.isFavorite(itemId)) {
        // If it is a favorite, remove it (use DELETE)
        response = await API.deleteWithToken(
          `${ENDPOINTS.DEL_FAVORITE_PRODUCTS}/${props.cusId}/${itemId}`
        );
        message = t("remove_favourite");
      } else {
        // If it is not a favorite, add it (use POST)
        response = await API.postWithToken(ENDPOINTS.ADD_FAVORITE_PRODUCTS, {
          productId: itemId,
          cusId: props.cusId,
        });
        message = t("added_to_favourite");
      }

      // Check if the request was successful
      if (response.statusText === "OK") {
         props.removeFavoriteLocally(itemId);
         props.setPage(1);
         //props.fetchFavoriteProducts(false); 
        //item.fetchFavoriteProducts(false);
        toast.success(message, {
          position: "bottom-left",
        });
      } 
    } catch (error) {
      toast.error("An error occurred while processing your request.", {
        position: "bottom-left",
      });
      console.error("Error adding/removing from favorites:", error);
    }

    setLoader(false);
  };
  if (!props.favouriteItems || !Array.isArray(props.favouriteItems)) {
    return <p>{t('no_result_found_txt')}</p>;
  }

  return (
    // <div className="heightscr- customscroll-" ref={props.listInnerRef}>
    <div className="Favourites_item customscroll-">
      {props.favouriteItems.map((item, index) => (
        <Item
          key={index}
          isFavorite={isFavorite}
          addToFavorite={addToFavorite}
          fetchFavoriteProducts={props.fetchFavoriteProducts}
          setError={setError}
          setSuccess={setSuccess}
          customer_id={props.cusId}
          //setPage={props.setPage}
          existingItemsInCart={existingItemsInCart}
          product={item?.productId ? item.productId : item}
          {...item.productId}
        />
      ))}
      
    </div>
    //  </div>
  );
}

export default Favouriteitems;
